/** @jsx jsx */

import { Fragment as _ } from 'react';
import { css, jsx } from '@emotion/core';
import { renderToString } from 'react-dom/server';

export const Flow = ({ color = '#66ccff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 415 242"
    preserveAspectRatio="xMidYMid slice"
    fill="none"
  >
    <g id="Flow" clipPath="url(#clip0_872_1038)">
      <path
        id="Vector"
        d="M0.000823975 242L414.826 242V0L0.000823975 0V242Z"
        fill={color}
      />
      <path
        id="Vector_2"
        opacity="0.15"
        d="M-1 142.327C32.893 148.413 69.662 145.41 103.564 129.482C155.861 104.912 198.171 81.961 252.363 81.899C334.201 81.805 387.408 118.392 414.676 143L414.676 0L-1 0L-1 142.327Z"
        fill="white"
      >
        <animate
          attributeName="d"
          values="M-1 142.327C32.893 148.413 69.662 145.41 103.564 129.482C155.861 104.912 198.171 81.961 252.363 81.899C334.201 81.805 387.408 118.392 414.676 143L414.676 0L-1 0L-1 142.327Z;M-1 98.5C17 134.5 73.098 140.928 107 125C167.5 100.5 195 93.9537 251.5 95C332.5 96.5 387.408 144.392 414.676 169L414.676 0L-1 0L-1 98.5Z;M-1 142.327C32.893 148.413 69.662 145.41 103.564 129.482C155.861 104.912 198.171 81.961 252.363 81.899C334.201 81.805 387.408 118.392 414.676 143L414.676 0L-1 0L-1 142.327Z"
          begin="0s"
          dur="8s"
          repeatCount="indefinite"
          fill="freeze"
          calcMode="linear"
          keyTimes="0;0.5;1"
        />
      </path>
    </g>
    <defs>
      <clipPath id="clip0_872_1038">
        <rect width="415" height="242" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const flowSVGToString = color => renderToString(<Flow color={color} />);
